import { Component } from '@angular/core';

@Component({
  selector: 'app-icon-check',
  standalone: true,
  templateUrl: './icon-check.component.html',
  styleUrl: './icon-check.component.css'
})
export class IconCheckComponent { }
